import React from 'react'
import { LazyLoad } from '../../common/Functions'

function Ecosystem() {
  return (
  <section className="max-w-screen-xl	mx-auto text-center">
    <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
      <div className="w-full flex flex-col justify-center items-center">
        <div className="content px-20 pb-20">
          <p className="text-left font-bold text-2xl">
            About the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            The Entrepreneurs' Organization (EO) is a global, peer-to-peer network of more than 14,000+ influential business owners with 198 chapters in 61 countries. EO Philippines is one of the chapters that decided to create its customized organization management portal. Back on our project kick-off meeting, the organization succeeding president initiated the development of an online tool with the features that can do the following: manage the members' personal, company, and family information; handle events that accept payments of members for reserving a slot; and post news, announcements, and videos to give updates to the members. 
          </p>
          <p className="text-left text-lg text-gray-600 mt-5">
            Our team proposed to develop a web portal for admins to manage the members' information, events, posts, and videos. Also, a mobile application for members where they can download it via Google Play or IOS Appstore and hassle-free attend events by conveniently paying their reservations online, read latest news and announcement from organization, and update their personal information. These web and mobile app solutions are the initial actions for EO PH in improving their system.
          </p>
        </div>
        <div className="content px-20 pb-20 ">
          <p className="text-left font-bold text-2xl">
            My Role in the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            I was the project manager and the lead UX/UI designer for this project. I created the proper style guides to follow and designed the UI components. I directly communicate with the EO PH user concerns and requests, including managing the jobs of the team members, project deliverables, and accomplishment reports. I additionally prepared user manuals for the users of the system.
          </p>
        </div>
        <em className="text-gray-400 mb-10">EO PH Admin Web App Mock-ups</em>
        <LazyLoad src={require('../../common/images/eo/web-mockup.png')} alt="EO PH Web Mockup"/>
        <em className="text-gray-400 py-10">EO PH Member Mobile App Mock-ups</em>
        <LazyLoad src={require('../../common/images/eo/mobile-mockup.png')} alt="EO PH Mobile Mockup"/>
      </div>
    </div>
  </section>
  )
}

export default Ecosystem
